import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'

class Dashboard {
  constructor () {
    this.baseURL = 'dashboard'
  }

  async getNotificationStats (clientId) {
    try {
      return (await getAxiosClient(this.baseURL)).get(`/notifications/${clientId}`)
    }
    catch (error) {
      CError(`Could not retrieve notifications stats from V2 API`, error)
      throw error
    }
  }
}

export default Dashboard
